import React, { useState } from 'react';
import './ContactForm.css';
import { FaMapMarkerAlt, FaPhone, FaEnvelope } from 'react-icons/fa';
import emailjs from 'emailjs-com';

const ContactForm = ({ language }) => {
  const [formData, setFormData] = useState({
    name: '',
    mobile: '+351',
    message: '',
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    
    const templateParams = {
      from_name: formData.name,
      from_mobile: formData.mobile,
      message: formData.message,
      date: new Date().toLocaleString(),
      to_email: "physioperformancecf@gmail.com"
    };

    console.log('Submitting form with params:', templateParams);

    emailjs.send(
      process.env.REACT_APP_EMAILJS_SERVICE_ID,
      process.env.REACT_APP_EMAILJS_TEMPLATE_ID,
      templateParams,
      process.env.REACT_APP_EMAILJS_PUBLIC_KEY
    )
    .then((response) => {
      if (response.status === 200) {
        console.log('✅ Email successfully sent:', response.status, response.text);
        alert(language === 'pt'
          ? '✅ Mensagem enviada com sucesso!'
          : '✅ Message sent successfully!');
        setFormData({ name: '', mobile: '+351', message: '' });
      } else {
        console.error('⚠️ Email send failed:', response.status, response.text);
        alert(language === 'pt'
          ? '⚠️ O envio falhou. Por favor, verifique seus detalhes e tente novamente.'
          : '⚠️ Sending failed. Please check your details and try again.');
      }
    })
    .catch((error) => {
      console.error('❌ EmailJS error:', error);
      alert(language === 'pt'
        ? '❌ Erro ao enviar. Por favor, tente novamente.'
        : '❌ Failed to send. Please try again.'+error.text);
    });

  };

  const t = {
    en: {
      title: "Contact Us",
      name: "Your Name",
      mobile: "Mobile Number",
      message: "Your Message",
      submit: "Send Message",
      availabilityNote: "Please indicate your availability in the form. We will contact you shortly to finalize your appointment.",
      address: "Where are we?"
    },
    pt: {
      title: "Contacte-nos",
      name: "O seu nome",
      mobile: "Número de telemóvel",
      message: "A sua mensagem",
      submit: "Enviar mensagem",
      availabilityNote: "Por favor, indique a sua disponibilidade no formulário. Entraremos em contacto consigo em breve para finalizar a marcação.",
      address: "Onde estamos?"
    },
  }[language];

  return (
    <>
      <div style={{ height: '90px' }}></div>
      <div className="contact-section-bg">
        <div className="page-wrapper">
          <div className="left-column">
            <form className="contact-form" onSubmit={handleSubmit}>
              <h2>{t.title}</h2>
              <p className="form-description">{t.availabilityNote}</p>

              <input
                type="text"
                name="name"
                placeholder={t.name}
                value={formData.name}
                onChange={handleChange}
                required
              />
              <input
                type="tel"
                name="mobile"
                placeholder={t.mobile}
                value={formData.mobile}
                onChange={handleChange}
                required
              />
              <textarea
                name="message"
                placeholder={t.message}
                value={formData.message}
                onChange={handleChange}
                rows="4"
                required
              />
              <button type="submit">{t.submit}</button>
            </form>
          </div>

          <div className="right-column">
            <h3 style={{ display: "flex", alignItems: "center", gap: "20px" }}>{t.address}</h3>

            <p style={{ display: "flex", alignItems: "center", gap: "10px" }}>
              <FaMapMarkerAlt style={{ color: "teal", fontSize: "1.5rem" }} />
              Rua Marcos Portugal 14B, 1495-091, Algés
            </p>

            <p style={{ display: "flex", alignItems: "center", gap: "10px" }}>
              <FaPhone style={{ color: "teal", fontSize: "1.5rem" }} />
              +351 966 926 937
            </p>

            <p style={{ display: "flex", alignItems: "center", gap: "10px" }}>
              <FaEnvelope style={{ color: "teal", fontSize: "1.5rem" }} />
              physioperformancecf@gmail.com
            </p>

            <div className="map-wrapper">
              <iframe
                title="Google Map"
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3110.9530163230784!2d-9.2295022!3d38.7077607!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0xd1ecd005e553f21%3A0x8a0ba779d039af1d!2sFOCUS%20-%20Sa%C3%BAde%20e%20Exerc%C3%ADcio!5e0!3m2!1sen!2spt!4v1717425741406!5m2!1sen!2spt"
                width="100%"
                height="300"
                allowFullScreen=""
                loading="lazy"
                style={{ border: 0, borderRadius: '12px', marginTop: '2rem' }}
                referrerPolicy="no-referrer-when-downgrade"
              ></iframe>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ContactForm;
